<template>
    <div class="photo-lower-bar-button-group">
        <div class="photo-lower-bar-button" v-on:click="editPhoto">
            <SVGAdminEditRow class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Редактировать</span>
        </div>
        <div class="photo-lower-bar-button" v-on:click="showModal('photo-delete-modal')">
            <SVGPhotoDelete class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Удалить</span>
        </div>
    </div>
</template>

<script>
    import {modalMethods} from "../../common.js";
    import SVGPhotoDelete from "../../SVG/SVGPhotoDelete";
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow";

    export default {
        name: "LeftLowerBarPhotoViewer",
        components: {
            SVGAdminEditRow,
            SVGPhotoDelete
        },
        mixins: [modalMethods],
        methods: {
            editPhoto() {
                this.$router.push({name: "EditPhoto"}).catch(() => {})
            }
        }
    }
</script>

<style scoped>

</style>
